export default "__VITE_ASSET__HeNeNjJ0__"